import React from 'react';
import { FileText, Calendar, Hash } from 'lucide-react';

/**
 * Компонент секции с деталями счета-фактуры
 */
const InvoiceDetailsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-indigo-50 dark:bg-indigo-900/20 p-4 rounded-lg border border-indigo-100 dark:border-indigo-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <FileText className="w-5 h-5 mr-2 text-indigo-500" />
        Данные для счета-фактуры
      </h3>
      
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
        Эти данные будут использованы при формировании печатной формы счета-фактуры
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Номер счета-фактуры */}
        <div>
          <label htmlFor="invoiceNumber" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Hash className="w-4 h-4 mr-2 text-indigo-500" />
            Номер счета-фактуры
          </label>
          <input
            type="text"
            id="invoiceNumber"
            name="invoiceNumber"
            value={formData.invoiceNumber || ''}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.invoiceNumber ? 'input-error' : ''}`}
            placeholder="Например: № 123"
          />
          {errors.invoiceNumber && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.invoiceNumber}
            </p>
          )}
        </div>

        {/* Дата счета-фактуры */}
        <div>
          <label htmlFor="invoiceDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calendar className="w-4 h-4 mr-2 text-indigo-500" />
            Дата счета-фактуры
          </label>
          <input
            type="date"
            id="invoiceDate"
            name="invoiceDate"
            value={formData.invoiceDate || formData.dateOfOperation}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.invoiceDate ? 'input-error' : ''}`}
          />
          {errors.invoiceDate && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.invoiceDate}
            </p>
          )}
        </div>

        {/* Продавец */}
        <div>
          <label htmlFor="seller" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Продавец (наименование организации)
          </label>
          <input
            type="text"
            id="seller"
            name="seller"
            value={formData.seller || ''}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.seller ? 'input-error' : ''}`}
            placeholder="ООО «Организация»"
          />
          {errors.seller && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.seller}
            </p>
          )}
        </div>

        {/* Покупатель */}
        <div>
          <label htmlFor="buyer" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Покупатель (наименование организации)
          </label>
          <input
            type="text"
            id="buyer"
            name="buyer"
            value={formData.buyer || ''}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.buyer ? 'input-error' : ''}`}
            placeholder="ИП Иванов И.И."
          />
          {errors.buyer && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.buyer}
            </p>
          )}
        </div>

        {/* ИНН/КПП продавца */}
        <div>
          <label htmlFor="sellerInn" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            ИНН/КПП продавца
          </label>
          <input
            type="text"
            id="sellerInn"
            name="sellerInn"
            value={formData.sellerInn || ''}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.sellerInn ? 'input-error' : ''}`}
            placeholder="7700123456/770001001"
          />
          {errors.sellerInn && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.sellerInn}
            </p>
          )}
        </div>

        {/* ИНН/КПП покупателя */}
        <div>
          <label htmlFor="buyerInn" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            ИНН/КПП покупателя
          </label>
          <input
            type="text"
            id="buyerInn"
            name="buyerInn"
            value={formData.buyerInn || ''}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.buyerInn ? 'input-error' : ''}`}
            placeholder="123456789012"
          />
          {errors.buyerInn && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.buyerInn}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 p-3 bg-indigo-100 dark:bg-indigo-900/30 border border-indigo-200 dark:border-indigo-800/70 rounded-lg text-sm text-indigo-700 dark:text-indigo-300">
        <p>
          Заполните эти поля, если хотите получить шаблон для создания счета-фактуры. 
          Заполнение не обязательно для расчета НДС.
        </p>
      </div>
    </div>
  );
};

export default InvoiceDetailsSection;